class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    // Create results container if it does not exist yet
    this.resultsInner = this.querySelector('#predictive-search-results');
    if (!this.resultsInner && this.predictiveSearchResults) {
      this.resultsInner = document.createElement('div');
      this.resultsInner.id = 'predictive-search-results';
      this.resultsInner.classList.add('predictive-search-results');

      const trending = this.predictiveSearchResults.querySelector('#trending-queries');
      const trendingMob = this.predictiveSearchResults.querySelector('#trending-queries-mb');
      if (trending) {
        trending.insertAdjacentElement('afterend', this.resultsInner);
      } else {
        this.predictiveSearchResults.appendChild(this.resultsInner);
      }
      if (trendingMob) {
        trendingMob.insertAdjacentElement('afterend', this.resultsInner);
      } else {
        this.predictiveSearchResults.appendChild(this.resultsInner);
      }
    }

    this.input.addEventListener(
      'input', 
      this.debounce((event) => { this.onChange(event); }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) { this.close(); return; }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((r) => { if (!r.ok) { this.close(); throw new Error(r.status); } return r.text(); })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');
        const fetchedResults = section && section.querySelector('#predictive-search-results');
        this.resultsInner.innerHTML = fetchedResults ? fetchedResults.innerHTML : '';
        this.open();
      })
      .catch((e) => { this.close(); throw e; });
  }

  open()  { if (this.predictiveSearchResults) this.predictiveSearchResults.style.display = 'block'; }
  close() { if (this.resultsInner) this.resultsInner.innerHTML = ''; if (this.predictiveSearchResults) this.predictiveSearchResults.style.display = 'none'; }

  debounce(fn, wait) { let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); }; }
}
customElements.define('predictive-search', PredictiveSearch);
